<template>
  <div>
    <!-- sub title -->
    <v-subheader class="px-2 all-menu-sub">
      <!-- sub title icon (기준: index) -->
      <icon-star v-if="categoryCd === '100'" class="sub-title-icon" />
      <icon-my-folder v-else-if="categoryCd === '200'" class="sub-title-icon" />
      <icon-edit v-else-if="categoryCd === '300'" class="sub-title-icon" />
      <icon-application-cancel
        v-else-if="categoryCd === '400'"
        class="sub-title-icon"
      />
      <icon-etc v-else class="sub-title-icon" />

      <!-- sub title name -->
      <span class="ml-2">{{ $t(categoryNm) }} </span>
    </v-subheader>

    <!-- detail menu list -->
    <v-list-item-group active-class="text--accent-4">
      <v-list-item
        v-for="(item, i) in menuList"
        :key="i"
        class="pl-6 pr-2"
        @click="toPage(item, i)"
      >
        <v-list-item-content>
          <v-list-item-title class="d-flex">
            {{ $t(item.menuNm) }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-icon v-if="item.pathName">
          <v-icon color="#9fa6ae">mdi-chevron-right</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list-item-group>
  </div>
</template>

<script>
/* 전체메뉴 메뉴목록 컴포넌트 */
import IconStar from '@/assets/customIcon/IconStar.vue';
import IconMyFolder from '@/assets/customIcon/IconMyFolder.vue';
import IconEdit from '@/assets/customIcon/IconEdit.vue';
import IconApplicationCancel from '@/assets/customIcon/IconApplicationCancel.vue';
import IconEtc from '@/assets/customIcon/IconEtc.vue';
import routerConstants from '@/const/routerConstants';

/* const */
import applCode from '@/const/applCodeConstants';
import routerNames from '@/const/routerConstants';

export default {
  props: {
    categoryNm: {
      type: String,
      required: true,
    },
    categoryCd: {
      type: String,
      default: '0',
    },
    menuList: {
      type: Array,
      required: true,
    },
  },

  methods: {
    /* 페이지 이동 */
    async toPage(item) {
      let routerName = item.pathName;

      if (routerName === routerConstants.Application) {
        // 파라미터 설정
        const applParam = {
          applCd: item.applCd,
          gntGubunCd: item.gntGubunCd,
          applOrgLvl: item.orgLvl, // 신청서의 예외 결재레벨 분리저장
        };

        switch (item.applCd) {
          // (25.5.12 예외추가) 제증명은 신청서종류를 선택후 기본 데이터를 셋팅해야함!
          case applCode.EmpCerti:
            routerName = routerNames.CertiTypeMenu;
            break;

          default:
            routerName = await this.$store.dispatch(
              'ELA/FETCH_MENU_ACTION',
              applParam,
            );
            break;
        }
      }

      this.$router.push({ name: routerName });
    },
  },

  components: {
    IconStar,
    IconMyFolder,
    IconEdit,
    IconApplicationCancel,
    IconEtc,
  },
};
</script>

<style scoped>
.v-subheader .sub-title-icon {
  width: 24px;
  height: 24px;
}

.v-list--nav .v-list-item:not(:last-child):not(:only-child) {
  margin-bottom: 0px;
}
</style>
